module.exports = __webpack_public_path__ + "img/logo.453a32b0.png";